import styled from 'styled-components';
import { Link } from 'react-router-dom';
import DetailedLogo from '../logo/DetailedLogo';
import { EmailContact, LocationContact, PhoneContact } from '../contact';
import { ABOUT_ROUTE, CONTACT_ROUTE, TERMS_ROUTE } from '../../routes';
import { siteUrl } from '../../site/resolveSite';
import { SHOW_ISLE_OF_MAN } from '../../site/flags';

const FooterContainer = styled.div`
    box-sizing: border-box;
    padding: 20px 30px 10px 30px;  
    font-family: ${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    color: ${({ theme }) => theme.colour.OFF_WHITE};
`

const FooterContent = styled.div`
    display: flex;
    justify-content: space-evenly;
    gap: 2.5rem;
    width: 100%;
    max-width: 68rem;
    margin: 0 auto;
    box-sizing: border-box;

    @media (max-width: 60rem) {
        flex-direction: column;
        align-items: flex-start;
        gap: 2rem;
    }
`

const FooterColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    min-width: 0;
    margin-top: 8px;
`

const Divider = styled.div`
    width: 100%;
    height: 2px;
    margin: 50px auto 20px auto;
    background-color: ${({ theme }) => theme.colour.COLOUR_MID_DARK};
`

const FooterLogoContainer = styled.div`
    flex-grow: 1;
    display: flex;
    justify-content: center;
`

const ColumnTitle = styled.h2`
    color: ${({ theme }) => theme.colour.OFF_WHITE};
    font-family: ${({ theme }) => theme.font.FONT_SERIF_ROBOTO_SERIF};
    font-weight: 700;
    font-size: 20px;
    margin-bottom: 6px;
`

const FooterLink = styled(Link)<{ textColor?: string; fontFamily?: string }>`
    color: ${({ textColor, theme }) => textColor ?? theme.colour.OFF_WHITE};
    font-family: ${({ fontFamily, theme }) => fontFamily ?? theme.font.FONT_SANS_RED_HAT_DISPLAY};
    font-size: 18px;
    margin-bottom: 10px;
    font-weight: 100;
    transition: color 150ms ease;

    &:hover {
        color: ${({ theme }) => theme.colour.COLOUR_LIGHT};
    }
`

const ExternalFooterLink = FooterLink.withComponent('a');

const FooterFooter = styled.section`
    background-color: ${({ theme }) => theme.colour.COLOUR_MID_LIGHT};
    font-family: ${({ theme }) => theme.font.FONT_SANS_RED_HAT_DISPLAY};
    width: 100%;
    min-height: 40px;
    box-sizing: border-box;
    padding: 0.5rem 20px;
    font-size: 16px;
    justify-content: space-between;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.5rem;
    font-weight: 100;
    color: ${({ theme }) => theme.colour.OFF_WHITE};
`

const SocialMediaIcon = styled.img`
    padding: 0 5px;
    position:relative;
`

export default function Footer(){
    const currentYear = new Date().getFullYear()

    return (
    <>
    <FooterContainer>
        <Divider data-physics/>
        <FooterContent>
            <FooterLogoContainer>
                <DetailedLogo />
            </FooterLogoContainer>
            <FooterColumn>
                <ColumnTitle>
                    Contact
                </ColumnTitle>
                <PhoneContact to="tel:+447504061916">
                    +44 (0)7504 061 916
                </PhoneContact>
                <EmailContact to="mailto:engineering@oneillsoft.com">
                    engineering@oneillsoft.com
                </EmailContact>
                <EmailContact to="mailto:engine@oneillsoft.com">
                    engine@oneillsoft.com
                </EmailContact>
                <EmailContact to="mailto:hardware@oneillsoft.com">
                    hardware@oneillsoft.com
                </EmailContact>
                {SHOW_ISLE_OF_MAN && (
                    <LocationContact>
                        {'San Remo, Coburg Road, Isle of Man\nIM8 3EH'}
                    </LocationContact>
                )}
            </FooterColumn>
            <FooterColumn>
                <ColumnTitle>
                    Links
                </ColumnTitle>
                <FooterLink to={ABOUT_ROUTE}>
                    About
                </FooterLink>
                <FooterLink to={TERMS_ROUTE}>
                    Terms & Conditions
                </FooterLink>
                <FooterLink to={CONTACT_ROUTE}>
                    Contact
                </FooterLink>
                <ExternalFooterLink href={siteUrl('engine')}>
                    Discreet Engine
                </ExternalFooterLink>
                <ExternalFooterLink href={siteUrl('hardware')}>
                    O'Neill Modular Hardware
                </ExternalFooterLink>
                <ExternalFooterLink href={siteUrl('education')}>
                    O'Neill Education
                </ExternalFooterLink>
            </FooterColumn>
        </FooterContent>
    </FooterContainer>
    <FooterFooter id='footer-footer'>
        <span>
            © {currentYear} O'Neill Group LLC{SHOW_ISLE_OF_MAN && ' | Registered in the Isle Of Man'}
        </span>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <SocialMediaIcon
                src='/assets/img/linkedin-network-communication-internet-interaction-svgrepo-com.svg'
                alt='linkedin icon'
                style={{ height: '28px', width: '28px', position: 'relative', bottom: '0.05em' }}
            />
            <SocialMediaIcon
                src='/assets/img/youtube-player-multimedia-video-communication-interaction-svgrepo-com.svg'
                alt='youtube icon'
                style={{ height: '21px', width: '30px' }}
            />
        </div>
    </FooterFooter>
    </>
    )
}